(() => {
  const openButton = document.querySelector(".footer [footer-open-klavio-popup]");
  const klavioPopup = document.querySelector("[klavio-popup]");
  const closeButton = document.querySelector("[klavio-popup-close]");
  const body = document.body;
  openButton.addEventListener("click", onPopupOpen);
  closeButton.addEventListener("click", onPopupClose);
  function onPopupOpen(e) {
    e.preventDefault();
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    body.dataset.scrollY = scrollY;

    body.style.top = `-${scrollY}px`;
    body.style.position = "fixed";
    body.style.overflow = "hidden";
    klavioPopup.classList.add("active");
    const modal = klavioPopup.querySelector(".singup-popup__modal");
    modal.style.top = `calc(${scrollY}px + ${viewportHeight / 2}px)`;
  }
  function onPopupClose(e) {
    klavioPopup.classList.remove("active");
    body.style.position = "";
    body.style.top = "";
    body.style.overflow = "auto";
    window.scrollTo(0, parseInt(body.dataset.scrollY || "0"));
  }
})();
